/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type EOBServiceLineRetirementReason = typeof EOBServiceLineRetirementReason[keyof typeof EOBServiceLineRetirementReason];


export const EOBServiceLineRetirementReason = {
  SupersededByCorrection: 'SupersededByCorrection',
  SupersededByLaterPosting: 'SupersededByLaterPosting',
  Reversed: 'Reversed',
  Reversal: 'Reversal',
} as const;
